import { collect } from "collect.js";

export function randomTypeHio() {
  return Math.floor(Math.random() * 3);
}

export function getNumberOfPayers(listBooked) {
  listBooked = collect(listBooked);
  let numberOfPayers = listBooked.where("type_purchase", "!=", 0).count();
  let totalPayers = listBooked.count();
  return `Đã thanh toán ${numberOfPayers}/${totalPayers} Pax`;
}

export function removeVietnameseTones(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, " ");
  str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " "
  );
  return str;
}

export const merchant = {
  VIETIN: 1, // Vietin Bank
  NAB: 2, // NAB Bank
  SCB: 3, // SCB Bank
  BIDV: 7
};

export const BANK_CONVERT = {
  1: 5, // Vietin Bank
  2: 4, // NAB Bank
  3: 6, // SCB Bank
  7: 7 // BIDV
};

export const TYPE_SERVICE = {
  BOOKING: 1,
  HIO: 2,
  OTHER: 3,
  SHOP: 4
};

export const ACTION_BIDV = {
  BACK_APP: "back_home",
  PAY: "payment"
};

export const partner_id_bidv = "wghn";

export const VALUE_TYPE_SERVICE = Object.fromEntries(
  Object.entries(TYPE_SERVICE).map(([key, value]) => [value, key])
);

export async function toggleChat(isShow = true) {
  const elements = document.querySelectorAll(".stringee_iframe_wrapper");
  if (elements.length > 0) {
    handleChat(elements, { isShow });
    return;
  }
  let retries = 30;
  while (retries >= 0) {
    const elements = document.querySelectorAll(".stringee_iframe_wrapper");
    if (elements.length > 0) {
      handleChat(elements, { isShow });
      return false;
    }
    if (retries > 0) {
      console.log("Retrying toggleChat...", retries);
      await new Promise(res => setTimeout(res, 100));
    } else {
      return false;
    }
    retries--;
  }
}

function handleChat(elements, options) {
  elements.forEach(element => {
    if (options.isShow) {
      element.classList.remove("custom_chat_bk");
    } else {
      element.classList.add("custom_chat_bk");
    }
  });
}

export function postMessageBidv(data) {
  // console.log("vào đây_______________", data);

  const dataJson = JSON.stringify(data);
  return window.webkit.messageHandlers.appEvent.postMessage(dataJson);
}
